import axios from 'axios';

export const defaults = {};

// @ts-ignore
export default (rest?:any) => ({
  Mutation: {
    apiSearch: async ({}: any, { type, keys, lang, country }: any, __: any) =>
      new Promise(async (resolve, reject) => {
        let options = {
          params:{ type, keys, lang, country }
        }
        await axios.get("/api/scraper", options).then(resolve).catch(()=>reject([]));
      })
  }
});
